import HttpService from "../util/HttpService";

class ImageService {
    uploadImage = (formData: any) => {
        return HttpService.postWithConfig("/video/api/v2/image-service/upload"
            , formData
            , {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=UTF-8;x-www-form-urlencoded'
                }, onUploadProgress: data => {

                },
            });
    }
}


const imageService = new ImageService();
export default imageService;